import React from 'react'
import { createWebSocket } from '../lib/websocket'
import store from '../redux/store'

const WebSocket = () => {
  React.useEffect(() => {
    createWebSocket()

    return () => {
      const { browser: { ws } } = store.getState()
      if (ws) {
        ws.close()
      }
    }
  }, [])

  return (
    <div />
  )
}

export default WebSocket
